import { call } from 'redux-saga/effects';

import { getLensInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { LensCard } from '~src/app/spaces/CardView/LensCard';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { MixedContentItemDefinition, SpaceDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { LensContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { Lenses } from '~src/ts/resources/Lenses';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const LensDefinition: MixedContentItemDefinition & SpaceDefinition<'lens'> = {
  itemType: 'lens',
  contentType: 'lens',
  singularName: Messages.lens,
  pluralName: Messages.lenses,
  emptyStateMessage: Messages.lensesEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Lenses,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.lensUrl(contentId),
  contentFilterKeys: LensContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: LensCard,
  listViewIconUrl: imgPath('spaces_medium_lens.svg'),
  filterClause: ServerFilterClauses.ContentType(['lens']) as ContentTypeFilterClause,
  getBasicQuery: () => Lenses.all(),
  fieldValueResourceType: 'lens',
  getContentInfo: (contentList: IContentInfo[]) => call(getLensInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: () => imgPath('spaces_masthead_lens.svg'),
};
